import React from "react"

/**
 * This will remove the preselected hotspot part from a url/path
 */
const removePreselectedHotspotFromUrl = (path, hotspotId, hotspotConfigIdentifier) => {
  let finalPath = path

  if (hotspotId) {
    finalPath = finalPath.replace(new RegExp(`/hsi/${hotspotId}` + '$'), "")
  }

  if (hotspotConfigIdentifier) {
    finalPath = finalPath.replace(new RegExp(`/hs/${hotspotConfigIdentifier}` + '$'), "");
  }

  return finalPath
}

export default removePreselectedHotspotFromUrl